import { useEffect, useState } from "react";

interface SwitchProps {
  defaultVal?: boolean;
  onChange?: (newValue: boolean) => void;
}

function Switch(props: SwitchProps) {
  const [toggle, setToggle] = useState<boolean>(props.defaultVal ?? false);
  const toggleClass = "transform translate-x-4";

  useEffect(() => {
    props.defaultVal && setToggle(props.defaultVal);
  }, [props.defaultVal]);

  const updateToggle: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
    const updatedValue = !toggle;
    props.onChange?.(updatedValue);
    setToggle(updatedValue);
  };

  return (
    <div
      className={
        "w-10 h-6 inline-flex items-center rounded-full pl-0.5 cursor-pointer duration-300 ease-in-out " +
        (!toggle ? "bg-brij-Grey" : "bg-brij-Blue")
      }
      onClick={updateToggle}
    >
      <div
        className={
          "bg-brij-White h-5 w-5 rounded-full shadow-md transform duration-300 ease-in-out" +
          (!toggle ? null : toggleClass)
        }
      />
    </div>
  );
}

export default Switch;
